import { ExclamationCircleIcon } from "@heroicons/react/solid";
import clsx from "clsx";
import { DraggableModal } from "Component/Modal";

const ConfirmModal = ({
    content = "Apakah Anda yakin ingin menghapus data Anda? Semua data Anda akan dihapus secara permanen dari server kami selamanya. Tindakan ini tidak dapat dibatalkan.",
    confirmText = "Hapus Data",
    confirmColor = "danger",
    title = "Hapus Data",
    open,
    toggleModal,
    onConfirm = () => {},
  }) => {
    return (
      <DraggableModal
        size="confirm-modal"
        open={open}
        toggleModal={() => toggleModal()}
      >
        <DraggableModal.Body className="py-4">
          <div className="absolute w-full top-0 left-0 h-6 bg-transparent cursor-move drag-handle" />
          <div className="flex items-center gap-4 mb-2">
            <ExclamationCircleIcon className="text-warning w-6 h-6" />
            <div
              className={clsx(
                "text-body-2 text-neutral-900 font-bold",
                "md:text-body-1"
              )}
            >
              {title}
            </div>
          </div>
          <div
            className={clsx(
              "ps-10 text-body-4 text-neutral-700 mb-4",
              "md:text-body-3"
            )}
          >
            {content}
          </div>
          <div className="flex items-center justify-end gap-4">
            <button
              className="border-btn-login border hover:bg-opacity-50 h-11 flex w-auto justify-center items-center rounded-xl px-3 py-1.5 text-sm font-semibold leading-6 text-btn-login shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              variant="flat-primary"
              onClick={() => toggleModal()}
            >
              Batal
            </button>
            <button
              className="bg-rose-900 hover:bg-opacity-50 h-11 flex w-auto justify-center items-center rounded-xl px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              variant={confirmColor}
              onClick={() => onConfirm()}
            >
              {confirmText}
            </button>
          </div>
        </DraggableModal.Body>
      </DraggableModal>
    );
  };
  
  ConfirmModal.displayName = "ConfirmModal";
  export { ConfirmModal };
  